import { makeStyles } from "@material-ui/core/styles"

const styles = makeStyles(theme => ({
  selectInput: {
    width: "210px",
    fontSize: "0.875rem",
    [theme.breakpoints.down("xs")]: {
      width: "100%",
    },
  },
}))

export default styles
